/**
 * PLAT-12074 — set on every panel the direction field portals to the page
 * body (the audio tag picker). A host that closes on click-away, such as the
 * Redub Selection popover, must treat a mousedown inside one as its own: the
 * panel is outside the host's DOM but belongs to it.
 *
 * Its own module so the field and the panels it opens can both read it
 * without importing each other.
 */
export const DUB_DIRECTION_PORTAL_ATTR = 'data-dub-direction-portal';
